import RootState from "../../state";
import directoryContactsParser from "./parsers";
import * as DirectoryAPI from "services/api/api.externalDirectory";
import { ThunkDispatch } from "redux-thunk";
import { IDirectoryFormState } from "views/Settings/DirectoryManagement/DirectoryItemForm/useDirectoryFormReducer";
import logger from "logger";
import { directoryContactParser } from "./parsers";
import { IExternalDirectoryActionTypes } from "./types";
import {
    deleteExternalDirectoryItemLoading,
    editExternalDirectoryItemLoading,
    getExternalDirectoryLoading,
    IExternalDirectoryActions,
    setExternalDirectoryContacts,
    setExternalDirectoryError,
    addExternalDirectoryItem as addExternalDirectoryItemAction,
} from "./actions";

export const getExternalDirectoryContacts = () => async (
    dispatch: ThunkDispatch<RootState, undefined, IExternalDirectoryActions>,
    getState: () => RootState
) => {
    const { app, directory, auth } = getState();

    if (
        (!directory.externalDirectory.contacts ||
            directory.externalDirectory.contacts.length === 0) &&
        !directory.externalDirectory.isLoading
    ) {
        try {
            dispatch(getExternalDirectoryLoading(true));

            const response = await DirectoryAPI.getContacts(app.ID, auth.token!)

            const parsedContacts = directoryContactsParser(response.data);

            dispatch(setExternalDirectoryContacts(parsedContacts));

            return parsedContacts;
        } catch (error) {
            logger.error("GET-DIRECTORY-CONTACTS", error as object);

            dispatch(
                setExternalDirectoryError(`Failed to fetch Directory contacts`)
            );
        } finally {
            dispatch(getExternalDirectoryLoading(false));
        }
    }

    return directory.externalDirectory.contacts;
};

export const addExternalDirectoryItem = (data: IDirectoryFormState) => {
    return async (
        dispatch: ThunkDispatch<
            RootState,
            undefined,
            IExternalDirectoryActions
        >,
        getState: () => RootState
    ) => {
        dispatch(editExternalDirectoryItemLoading(true));

        try {
            const { app, auth } = getState();

            const response = await DirectoryAPI.postContact(
                app.ID,
                auth.token!,
                data
            );

            dispatch(
                addExternalDirectoryItemAction(
                    directoryContactParser(response.data)
                )
            );
        } catch (error) {
            logger.error("ADD-DIRECTORY-ITEM", error as object);
        }
    };
};

export const editExternalDirectoryItem = (
    id: string,
    data: IDirectoryFormState
) => {
    return async (
        dispatch: ThunkDispatch<
            RootState,
            undefined,
            IExternalDirectoryActions
        >,
        getState: () => RootState
    ) => {
        try {
            dispatch(editExternalDirectoryItemLoading(true));

            const { app, auth } = getState();

            const response = await DirectoryAPI.putContactById(
                app.ID,
                auth.token!,
                id,
                data
            );

            dispatch({
                type:
                    IExternalDirectoryActionTypes.EDIT_EXTERNAL_DIRECTORY_ITEM,
                payload: directoryContactParser(response.data),
            });
        } catch (error) {
            logger.error("EDIT-DIRECTORY-ITEM", error as object);
        }
    };
};

export const deleteExternalDirectoryItem = (itemID: string) => {
    return async (
        dispatch: ThunkDispatch<
            RootState,
            undefined,
            IExternalDirectoryActions
        >,
        getState: () => RootState
    ) => {
        dispatch(deleteExternalDirectoryItemLoading(true));

        try {
            const { app, auth } = getState();

            await DirectoryAPI.deleteContactById(app.ID, auth.token!, itemID);

            dispatch({
                type:
                    IExternalDirectoryActionTypes.DELETE_EXTERNAL_DIRECTORY_ITEM,
                payload: itemID,
            });
        } catch (err) {
            logger.error("DELETE-DIRECTORY-ITEM", err as object);
        }
    };
};
